exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.cp-tabs[data-v-175ddb66] {\n  position: sticky;\n  top: 0;\n  background: #fff;\n  z-index: 10;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  padding: 6px 0 10px;\n}\n.cp-tab[data-v-175ddb66] {\n  background: #ffb452;\n  color: #fff;\n  padding: 0 12px;\n  height: 36px;\n  line-height: 36px;\n  font-size: 16px;\n  font-weight: 500;\n  border-radius: 5px;\n  cursor: pointer;\n  white-space: nowrap;\n}\n.cp-tab.active[data-v-175ddb66] {\n  background: #d4820f;\n}\n.cp-img[data-v-175ddb66] {\n  display: block;\n  width: 736px;\n  height: auto;\n  margin-bottom: 8px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-175ddb66","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/page/train/FBT/components/CourseProductModal.vue
// module id = 1719
// module chunks = 0